<template>
  <div class="newsfeed">
    <v-dialog v-model="addEditDialog" persistent max-width="900">
      <v-overlay :value="loadingImg">
        <v-progress-circular color="primary" indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-card>
        <v-card-title class="headline">
          <v-row>
            <v-col>{{ isEdit ? "Edit" : "Add" }} News Feed</v-col>
            <v-col md="1" class="float-right">
              <!-- <v-btn icon @click="setEnableEdit()" class="mr-2 ml-2" color="primary" v-if="isEdit">
                <v-icon>mdi-pencil</v-icon>
              </v-btn> -->

              <v-btn icon @click="addEditDialog = false" class="mr-2 ml-2">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-form ref="watchForm" v-model="valid">
            <v-card>
              <v-card-text>
                <!-- Avatar -->
                <!-- <v-row>
                  <v-col md="3">
                    <v-text-field class="form-control" label="Reporter" disabled></v-text-field>
                  </v-col>
                  <v-col md="9">
                    <v-row>
                      <v-col md="2">
                        <v-avatar size="75" class="ma-1">
                          <img
                            :src="form.avatar"
                            alt="Avatar"
                            onerror="this.onerror=null;this.src='img/logo_initial_gradient.png'"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col>
                        <v-card-title>HRD</v-card-title>
                        <v-card-subtitle>test</v-card-subtitle>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>-->

                <!-- Audience -->
                <!-- <v-row>
                  <v-col md="3">
                    <v-text-field class="form-control" label="Audience" disabled></v-text-field>
                  </v-col>
                  <v-col md="9">
                    <v-autocomplete
                      label="Audience"
                      :items="[{ id: 1, name: 'All Group' },{ id: 0, name: 'Test Group' }]"
                      v-model="form.audience"
                      item-text="name"
                      item-value="id"
                    ></v-autocomplete>
                    <span
                      v-if="form.audience == 1"
                    >Pesan ini akan terkirim ke semua group di perusahaan anda</span>
                    <span
                      v-if="form.audience == 0"
                    >Pesan ini akan terkirim ke group terpilih di perusahaan anda</span>
                  </v-col>
                </v-row>-->

                <!-- Subject -->
                <v-row>
                  <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Subject" disabled></v-text-field>
                  </v-col>-->

                  <v-col>
                    <v-autocomplete
                      label="Company"
                      v-model="form.selectedCompany"
                      :disabled="isEdit == true"
                      :items="companyList"
                      item-text="name_company"
                      item-value="id"
                      multiple
                      chips
                      required
                      :rules="rules2"
                    ></v-autocomplete>
                  </v-col>
                  <v-col md="2" class="mt-4" v-if="isEdit != true">
                    <v-btn color="primary" @click="selectAllCompany" :disabled="isEdit == true">
                      All
                    </v-btn>
                  </v-col>
                  <v-col md="12">
                    <v-text-field
                      label="Subject"
                      v-model="form.subject"
                      counter="50"
                      :disabled="isEdit == true"
                      @keyup="limitChar($event.target.value, 50, 'subject')"
                      :rules="rules"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Description -->
                <v-row>
                  <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Description" disabled></v-text-field>
                  </v-col>-->
                  <v-col>
                    <v-textarea
                      auto-grow
                      label="Description"
                      class="form-control"
                      rows="1"
                      v-model="form.description"
                      counter="2000"
                      @keyup="limitChar($event.target.value, 2000, 'description')"
                      :disabled="isEdit == true"
                      :rules="rules"
                      required
                    ></v-textarea>
                  </v-col>
                </v-row>

                <!-- Attachment -->
                <v-row>
                  <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Attachment" disabled></v-text-field>
                  </v-col>-->
                  <v-col md="12" class="pt-0 pb-0">
                    <label>Attachment</label>
                  </v-col>
                  <v-col>
                    <v-row>
                      <v-col md="4">
                        <img :src="form.image.one.url" @error="setAltImage" alt="img" width="100%" />
                        <v-file-input
                          accept="image/*"
                          @change="previewImage(1)"
                          v-model="form.image.one.data"
                          messages="Ini akan menjadi Cover"
                          :disabled="isEdit == true"
                        ></v-file-input>
                      </v-col>
                      <v-col md="4">
                        <img :src="form.image.two.url" @error="setAltImage" alt="img" width="100%" />
                        <v-file-input
                          accept="image/*"
                          @change="previewImage(2)"
                          v-model="form.image.two.data"
                          :disabled="isEdit == true"
                        ></v-file-input>
                      </v-col>
                      <v-col md="4">
                        <img
                          :src="form.image.three.url"
                          @error="setAltImage"
                          alt="img"
                          width="100%"
                        />
                        <v-file-input
                          accept="image/*"
                          @change="previewImage(3)"
                          v-model="form.image.three.data"
                          :disabled="isEdit == true"
                        ></v-file-input>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <!-- Status -->
                <v-row>
                  <!-- <v-col md="3">
                    <v-text-field class="form-control" label="Status" disabled></v-text-field>
                  </v-col>-->
                  <v-col md="12" class="pb-0">
                    <label v-if="enableEdit == false">Status</label>
                    <label v-if="isEdit == true && enableEdit == true">
                      <b class="text--black">Status</b>
                    </label>
                  </v-col>
                  <v-col class="pt-0">
                    <v-switch
                      class="pt-0"
                      label="Active"
                      v-model="form.status"
                      :disabled="isEdit == true && enableEdit == false"
                    ></v-switch>
                    <span
                      v-if="form.status"
                    >Informasi ini akan tampil dihalaman mobile milik Audience</span>
                    <span v-if="!form.status">
                      Informasi ini
                      <b>tidak</b> akan tampil dihalaman mobile milik Audience
                    </span>
                  </v-col>
                </v-row>

                <!-- End Row -->
              </v-card-text>
            </v-card>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="addEditDialog = false">Cancel</v-btn>
          <v-btn
            :loading="loading"
            color="primary"
            @click="save(form)"
            :disabled="(isEdit == true && enableEdit == false) || !valid"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <h2>News Feed</h2>
      <v-card class="px-6 pb-0 mb-3 mt-3">
        <v-row>
          <v-col md="3" class="mt-2">
            <v-btn
              color="primary"
              dark
              class="mb-2"
              @click="openAddEditDialog()"
              block
            >Add News Feed</v-btn>
          </v-col>
          <!-- <v-col md="3" class="pb-0">
            <v-menu
              ref="menu"
              v-model="menu_start"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFormatted(start_date)"
                  label="Start Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker v-model="start_date" @change="onStartDateChange" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="3" class="pb-0">
            <v-menu
              ref="menu"
              v-model="menu_end"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateFormatted(end_date)"
                  label="End Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-on="on"
                  color="primary"
                ></v-text-field>
              </template>
              <v-date-picker v-model="end_date" @change="onEndDateChange" :min="start_date" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col> -->
          <v-col md="3">
            <v-autocomplete
              label="Status"
              :items="[
                { id: '', name: 'All Status' },
                { id: true, name: 'Aktif' },
                { id: false, name: 'Tidak Aktif' },
              ]"
              v-model="status"
              item-text="name"
              item-value="id"
              @change="getData()"
            ></v-autocomplete>
          </v-col>
          <v-col md="3" offset="3">
            <v-text-field class="form-control" label="Search" v-model="search" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
          </v-col>
          <!-- <v-col md="3" class="pa-6">
            <v-btn block color="primary" @click="onSelectUser">
              <v-icon>mdi-magnify</v-icon>Search
            </v-btn>
          </v-col>-->
        </v-row>
      </v-card>
    </v-container>

    <v-container>
      <v-card>
        <v-data-table
          v-if="!firstLoad"
          :loading="loading"
          :headers="headers"
          :items="items"
          class="elevation-1"
          :disable-sort="disableSort"
          :search="search"
          :no-data-text="$t('no_data')"
          :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
        >
         <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
          <template
            v-slot:item.createdAt="{ item }"
          >{{ dateFormatted(item.createdAt) }} {{ dateFormattedHour(item.createdAt) }}</template>

          <template v-slot:item.action="{ item }">
            <v-btn icon @click="openAddEditDialog(true, item)" color="primary">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <template v-slot:item.isActive="{ item }">
            <span v-if="item.isActive">Aktif</span>
            <span v-if="!item.isActive" class="red--text">Tidak Aktif</span>
          </template>
        </v-data-table>
      </v-card>
      <v-skeleton-loader class="mx-auto" type="table-tbody" v-if="firstLoad && loading"></v-skeleton-loader>
    </v-container>
  </div>
</template>
<script>
import axios from "axios"
import * as moment from "moment"
import ENV from './../../store/modules/environtment'

export default {
  name: "newsfeeed-master",
  data() {
    return {
      valid: false,
      loadingImg: false,
      form: {
        selectedCompany: [],
        id: null,
        avatar: 'img/default-image.png',
        image: {
          one: { data: null, url: 'img/default-image.png', path: null },
          two: { data: null, url: 'img/default-image.png', path: null },
          three: { data: null, url: 'img/default-image.png', path: null },
        },
        subject: '',
        description: '',
      },
      isEdit: false,
      enableEdit: false,
      addEditDialog: false,
      firstLoad: true,
      disableSort: true,
      totalData: 0,
      page: 1,
      itemPerPage: 10,
      headers: [
        { text: "Publish Date", value: "createdAt", width: '10%' },
        { text: "Subject", value: "subject", width: '20%' },
        { text: "Detail Broadcast", value: "description", width: '50%' },
        { text: "Status", value: "isActive", width: '10%' },
        { text: "Action", value: "action", width: '10%' },
      ],
      baseUrl: this.$store.state.baseUrl,
      status: '',
      loading: true,
      editedIndex: -1,
      search: "",
      userList: [],
      items: [],
      menu_start: false,
      menu_end: false,
      start_date: "",
      end_date: "",
      companyList: [],
      selectedCompany: [],
      rules: [(value) => !!value || this.$i18n.t('required')],
      rules2: [(value) =>(value.length == 0 ? false: !!value || this.$i18n.t('required'))],
    };
  },
  computed: {},
  methods: {
    selectAllCompany() {
      if (this.form.selectedCompany.length == this.companyList.length) {
        this.form.selectedCompany = []
      } else {
        this.form.selectedCompany = []
        this.companyList.map(item => {
          setTimeout(() => {
            this.form.selectedCompany.push(item.id)
          }, 10);
        })
      }
    },
    limitChar(str, limit, type) {
      if (str.length > limit) {
        this.showMessage('warning', 'Reach maximum limit character')
        this.form[type] = str.substr(0, limit)
      }
    },
    setAltImage(event) {
      event.target.src = '/img/default-image.png'
    },
    showMessage(type, msg) {
      this.$store.dispatch('nShowMessage', {type, msg})
    },
    setEnableEdit() {
      this.enableEdit = true
    },
    async getCompanyList() {
      this.loading = true
      const result = await this.$store.dispatch('getCompanyList')
      this.loading = false
      this.companyList =  result
    },
    async getData(page = 1, itemPerPage = 10) {
      this.loading = true
      this.page = page
      this.itemPerPage = itemPerPage
      const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
      const start = this.page - 1;
      const dateStart = moment(this.start_date).format('DD-MM-YYYY')
      const dateEnd = moment(this.end_date).format('DD-MM-YYYY')
      const result = await this.$store.dispatch('getNewsFeedMaster', {
        page: start,
        pageSize: totalPageSend,
        isMobile: false,
        startDate: dateStart,
        endDate: dateEnd,
        isActive: this.status
      })
      if (result) {
        this.items = result.rows
        this.totalData = result.count
      }
      this.loading = false
      this.firstLoad = false
    },
    async save(form) {
      const prefix = ENV.firebase.prefixNewsFeed
      const companyId = this.$store.state.company
      const userId = this.$store.state.user.id
      const attachmentPrefix = `${prefix}${companyId}/${userId}/news_feed`
      const body = {
        id: form.id,
        subject: form.subject,
        description: form.description,
        attachmentPrefix,
        attachments: [
          { attachment: form.image.one.path, isCover: true },
          { attachment: form.image.two.path, isCover: false },
          { attachment: form.image.three.path, isCover: false },
        ],
        companies: form.selectedCompany,
        isActive: form.status
      }
      if (body.subject.length > 50) {
        this.showMessage('warning', 'Subject Exceeded Maximum Character')
        return null
      }
      if (body.description.length > 2000) {
        this.showMessage('warning', 'Description Exceeded Maximum Character')
        return null
      }

      let result
      this.loading = true
      if (this.isEdit) {
        result = await this.$store.dispatch('editNewsFeedMaster', body)
        
      } else {
        result = await this.$store.dispatch('saveNewsFeedMaster', body)
      }      
      this.loading = false
      if (result) {
        this.showMessage('success', `${this.isEdit ? 'Update' : 'Simpan'} Berhasil`)
        this.addEditDialog = false
        this.getData(this.page, this.itemPerPage)
      }
    },

    async previewImage(num) {
      switch (num) {
        case 1:
          if (this.form.image.one.data) {
            this.loadingImg = true
            const data = await this.uploadImage(this.form.image.one.data)
            this.loadingImg = false
            this.form.image.one.url = URL.createObjectURL(this.form.image.one.data)
            this.form.image.one.path = data.fileName
          } else {
            this.form.image.one.url = 'img/default-image.png'
          }
          break
        case 2:
          if (this.form.image.two.data) {
            this.loadingImg = true
            const data = await this.uploadImage(this.form.image.two.data)
            this.loadingImg = false
            this.form.image.two.url = URL.createObjectURL(this.form.image.two.data)
            this.form.image.two.path = data.fileName
          } else {
            this.form.image.two.url = 'img/default-image.png'
          }
          break
        case 3:
          if (this.form.image.three.data) {
            this.loadingImg = true
            const data = await this.uploadImage(this.form.image.three.data)
            this.loadingImg = false
            this.form.image.three.url = URL.createObjectURL(this.form.image.three.data)
            this.form.image.three.path = data.fileName
          } else {
            this.form.image.three.url = 'img/default-image.png'
          }
          break
      }
    },
    openAddEditDialog(isEdit = false, item = null) {
      this.isEdit = isEdit
      this.enableEdit = false
      this.addEditDialog = true
      if (isEdit) {
        this.form.id = item.id
        this.form.subject = item.subject
        this.form.description = item.description
        this.form.image.one.url = item.attachments[0] ? item.attachments[0].attachment : 'img/default-image.png'
        this.form.image.two.url = item.attachments[1] ? item.attachments[1].attachment : 'img/default-image.png'
        this.form.image.three.url = item.attachments[2] ? item.attachments[2].attachment : 'img/default-image.png'
        this.form.status = item.isActive
        this.form.selectedCompany = []
        item.companies.map(e => { this.form.selectedCompany.push(e.companyId) })
        this.setEnableEdit()
      }
    },
    getAction(action) {
      switch (action) {
        case "add":
          return {
            icon: "mdi-plus-circle-outline",
            color: "primary",
            action: "Create Data "
          };
        case "view":
          return { icon: "mdi-eye", color: "success", action: "View Data" };
        case "edit":
          return {
            // icon: "mdi-tooltip-edit",
            icon: "mdi-pen",
            color: "warning",
            action: "Edit Data"
          };
        case "delete":
          return {
            icon: "mdi-delete",
            color: "error",
            action: "Delete Data"
          };
        case "download":
          return {
            icon: "mdi-download",
            color: "info",
            action: "Download Data"
          };

        default:
          return {
            icon: "mdi-guitar-pick-outline",
            color: "#033B6D",
            action: `${action} Data`
          };
      }
    },
    dateFormatted(date) {
      return moment(date).format("DD MMMM YYYY");
    },
    dateFormattedHour(date) {
      return moment(date).format("HH:mm:ss");
    },
    queryDate(date) {
      return moment(date).format("MM-DD-YYYY");
    },
    queryDatePlus(date, day) {
      return moment(date)
        .add(day, "days")
        .format("MM-DD-YYYY");
    },
    onSelectUser() {
      // setTimeout(() => {
      //   this.id = "";
      // }, 3000);
    },
    onStartDateChange() {
      const diff = moment(this.end_date).diff(this.start_date, 'days')
      if (diff < 0) this.end_date = this.start_date
      this.menu_start = false;
      this.getData()
    },
    onEndDateChange() {
      this.menu_end = false;
      this.getData()
    },

    getUserList() {
      let company_id = this.$store.state.company;
      let url = `${this.baseUrl}/user/listbycompanyidnonpagination?companyId=${company_id}`;
      return axios.get(url, { headers: { action: 'Get User', actionId: 4 } }).then(res => {
        this.userList = [];
        res.data.data.rows.forEach(row => {
          let user = row;
          this.userList.push(user);
        });
      });
    },

    async uploadImage(image) {
      const prefix = ENV.firebase.prefixNewsFeed
      const companyId = this.$store.state.company
      const url = `${this.baseUrl}/download/fileupload`
      const headers = { headers: { 'Content-Type': 'multipart/form-data', action: 'File Upload', actionId: 1 } }
      try {
        const formData = new FormData();
        formData.append('file', image)
        formData.append('path', `${prefix}${companyId}`)

        const result = await axios.post(url, formData, headers)
        if (result) {
          if (result.data.code == 200) return result.data.data
        }
        return { url: 'img/default-image.png' }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e.message)
        return { url: 'img/default-image.png' }
      }
    },
  },
  watch: {
    addEditDialog(show) {
      if (show && !this.isEdit) {
        this.form = {
          selectedCompany: [],
          avatar: 'img/default-image.png',
          image: {
            one: { data: null, url: 'img/default-image.png', path: null },
            two: { data: null, url: 'img/default-image.png', path: null },
            three: { data: null, url: 'img/default-image.png', path: null },
          },
          subject: '',
          description: '',
        }
        if (this.$refs.watchForm) {
          this.$refs.watchForm.reset()
        }
      } else {
        if (this.$refs.watchForm) {
          // this.$refs.watchForm.reset()
        }
      }
    },
  },
  created() {
    this.start_date = moment('2019', 'YYYY')
      .startOf("month")
      .format("YYYY-MM-DD");
    this.end_date = moment().format("YYYY-MM-DD");
    this.getData()
    this.getCompanyList()
  }
};
</script>